import { render } from "./OrderDish.vue?vue&type=template&id=369aa674&lang=pug"
import script from "./OrderDish.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDish.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__